import "./Footer.css"
import React from 'react'

const Footer = () => {
  return (
<footer className="footer">
  <div className="footer__container bd-container">
    <h2 className="footer__title">HuBMAP</h2>
    <p className="footer__description">HuBMAP - Hacking the Human Vasculature Competition 09/2023</p>
    <p className="footer__copy"> 2024 HuBMAP. All right reserved</p>
  </div>
</footer>
  )
}

export default Footer